function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.49,312.48a4,4,0,0,0,5.09-2.46l6.65-19.12a4,4,0,0,0-2.46-5.09,4.06,4.06,0,0,0-1.32-.22,4,4,0,0,0-3.78,2.69L93,307.39A4,4,0,0,0,95.49,312.48Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6,274.55l-17.18,8.31a4,4,0,0,0,3.48,7.2l17.18-8.31a4,4,0,0,0-1.75-7.61A3.85,3.85,0,0,0,91.6,274.55Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73,260.31,89.85,267a4,4,0,0,0,2.63-7.55l-19.12-6.65a4,4,0,0,0-1.31-.22,4,4,0,0,0-1.32,7.77Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.43,192.32a26.7,26.7,0,0,1-5.51-16.22V119.62a6.47,6.47,0,0,1,6.47-6.47,4,4,0,0,0,0-8,14.48,14.48,0,0,0-14.47,14.47V176.1a34.78,34.78,0,0,0,7.17,21.1l33.17,43.14a19,19,0,0,1-15,30.51H144.11a19,19,0,0,1-15-30.51l33.17-43.14a34.84,34.84,0,0,0,7.17-21.1V119.62A14.48,14.48,0,0,0,155,105.15a4,4,0,0,0,0,8,6.47,6.47,0,0,1,6.47,6.47V176.1a26.76,26.76,0,0,1-5.51,16.22l-33.17,43.14a27,27,0,0,0,21.37,43.39h83.12a27,27,0,0,0,21.37-43.39Z",
    style: {
      fill: "#9da0a4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.56,173.73a4,4,0,0,0-5.1,2.46l-6.64,19.11a4,4,0,1,0,7.55,2.63L270,178.82A4,4,0,0,0,267.56,173.73Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.45,211.66l17.18-8.31a4,4,0,1,0-3.49-7.2L268,204.46a4,4,0,0,0,1.74,7.6A3.85,3.85,0,0,0,271.45,211.66Z",
    style: {
      fill: "#ef5051"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.32,225.89l-19.12-6.65a4,4,0,0,0-2.63,7.56l19.12,6.65a4,4,0,0,0,2.63-7.56Z",
    style: {
      fill: "#ef5051"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.ce60d3d1cd16b47941fa183eeadb27f6.svg";
export { ForwardRef as ReactComponent };